<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-12 09:51:22
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-23 16:04:48
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\goodsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row">
		<div>
			<el-avatar shape="square" :size="60" :src="row.productPic"></el-avatar>
		</div>
		<div class="ml-8">
			<div class="flex-row-align-center">
				<platform-icon :platformId="row.platformId" style="flex-shrink: 0"></platform-icon>
				<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.outerProductName">
					<span class="ml-4 yx-color-text-primary font-h6-medium line-ellipsis-1 cursor-pointer hover" style="max-width: 180px" @click="skipFun(row)">
						{{ row.outerProductName }}
					</span>
				</el-tooltip>
				<ID-tag label="商品ID" :id="row.outerProductId" />
			</div>
			<div class="font-h6-regular yx-color-text-secondary mt-2">
				<span>日常价</span>
				<span class="ml-2">{{ row.salePrice | formatEmpty | formatPrice2 | formatPrice }}</span>
				<span class="ml-12">销量</span>
				<span class="ml-2">{{ row.orderNum | formatEmpty | formatPrice2 }}</span>
			</div>
			<div class="font-h6-regular yx-color-text-secondary flex-row-align-center mt-2">
				<span>普通佣金率</span>
				<span class="ml-2">{{ row.baseCommissionRate | formatPercent2 }}</span>
				<span class="ml-4">库存</span>
				<span class="ml-2">{{ row.stockNum | formatEmpty | formatPrice2 }}</span>
			</div>
		</div>
	</div>
</template>
<script>
import { drRoleType } from '@/utils/dataMap';
import IDTag from '@/components/ui/IDTag';
import mixin from '@/components/tableCells/mixin';
export default {
	components: {
		IDTag,
	},
	mixins: [mixin],
	computed: {
		drName() {
			return drRoleType.name;
		},
	},
	data() {
		return {};
	},
	methods: {
		async skipFun({ productUrl }) {
			window.open(productUrl, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.tag {
	padding: 0 3px;
	border-radius: 3px;
	background-color: #f7f8fa;
	margin-left: 4px;
}
.reissue {
	width: 52px;
	height: 18px;
	line-height: 18px;
	padding: 0 4px;
	background-color: #fef3e7;
	font-size: 12px;
	text-align: center;
}
</style>